var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headerTop",staticStyle:{"border":"1px solid red"},style:({
    height: _vm.pageSetup.titleHeight + 'px',
  })},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pageSetup.isBack),expression:"pageSetup.isBack"}],staticClass:"lef"},[_c('van-icon',{attrs:{"name":"arrow-left"}})],1),_c('div',{staticClass:"header-title",style:({
      height: _vm.pageSetup.titleHeight + 'px',
      'line-height': _vm.pageSetup.titleHeight + 'px',
    })},[_vm._v(" "+_vm._s(_vm.pageSetup.name)+" ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pageSetup.isPerson),expression:"pageSetup.isPerson"}],staticClass:"rig"},[_c('span',[_vm._v("个人中心")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }